import { FontFormat, Typography, TypographySetting } from '@celum/portals/domain';

const defaultTypographySettings: TypographySetting = {
  font: { identifier: 'Open Sans', type: 'default' },
  fontWeight: 400,
  fontSize: 16,
  lineHeight: 1.2,
  fontColorId: 'gray-5',
  key: 'heading-1',
  formatting: []
};

export const defaultTypographyConfiguration: Typography = {
  mainFont: { identifier: 'Open Sans', type: 'default' },
  settings: [
    createTypographySettings({ key: 'heading-1', fontSize: 32, fontWeight: 700, formatting: [FontFormat.UPPERCASE] }),
    createTypographySettings({ key: 'heading-2', fontSize: 24, fontWeight: 700 }),
    createTypographySettings({ key: 'heading-3', fontSize: 20 }),
    createTypographySettings({ key: 'body', fontSize: 13, lineHeight: 1.5 }),
    createTypographySettings({ key: 'quote', fontSize: 24, lineHeight: 1.5, formatting: [FontFormat.ITALIC], fontColorId: 'primary' })
  ]
};

function createTypographySettings(settings: Partial<TypographySetting>): TypographySetting {
  return { ...defaultTypographySettings, ...settings };
}
